import React from 'react';
import styled from 'styled-components/macro';
import { Heading } from 'components/Heading/Heading';
import { Paragraph } from 'components/Paragraph/Paragraph';
import { ReactComponent as DeviceRotate } from 'assets/icons/device-rotate.svg';
import czoLogo from 'assets/images/czo-logo.png';

const StyledPortrait = styled.div`
  padding: ${({ theme }) => `${theme.spacing[2]}`};
  height: 100%;
  display: flex;
  flex-direction: column;
`;

const StyledPortraitLogo = styled.img`
  margin: auto;
`;

const StyledPortraitContent = styled.div`
  text-align: center;
  padding: ${({ theme }) => `${theme.spacing[8]} ${theme.spacing[3]}`};
  background: ${({ theme }) => theme.colors.green};
  color: ${({ theme }) => theme.colors.black};
  border-radius: ${({ theme }) => theme.radius.full};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 100%;
  z-index: 100;
  margin-top: ${({ theme }) => theme.spacing[3]};
  max-width: 400px;
  margin-left: auto;
  margin-right: auto;
`;

const StyledPortraitIcon = styled(DeviceRotate)`
  margin-bottom: ${({ theme }) => theme.spacing[4]};
`;

const StyledPortraitProtip = styled.p`
  max-width: 75%;
`;

export const ContainerPortrait: React.FC = () => {
  return (
    <StyledPortrait>
      <StyledPortraitLogo src={czoLogo} />
      <StyledPortraitContent>
        <div>
          <StyledPortraitIcon />
          <Heading as="h2">Wil je aan de slag?</Heading>
          {/* eslint-disable-next-line max-len */}
          <Paragraph>Deze interactive is geoptimaliseerd om te bekijken in landschapmodus. Draai je device om de interactive te kunnen bekijken en gebuiken.</Paragraph>
        </div>
        {/* eslint-disable-next-line max-len */}
        <StyledPortraitProtip><b>Pro tip:</b> Hoewel deze interactive te bekijken is op mobiel ervaar je deze het beste op laptop of tablet.</StyledPortraitProtip>
      </StyledPortraitContent>
    </StyledPortrait>
  );
};